import { Injectable } from '@angular/core';
import { API } from '../view-models/Constants';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public BaseURL = API.prodBaseURL;
  public apiKey = "msnd19829ASDn8786SS"
  
  constructor(public http: HttpClient, private cookie: CookieService) { }

  private getAuthHeaders(): HttpHeaders {
    const token = this.cookie.get('access_token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  httpGetHelp(apiURL: string): Observable<any> {
    return this.http.get<any>(this.BaseURL + apiURL, {
      headers: this.getAuthHeaders()
    });
  }

  httpPostHelp(apiURL: string, data: any): Observable<any> {
    return this.http.post<any>(this.BaseURL + apiURL, data, {
      headers: this.getAuthHeaders()
    });
  }

  refreshAccessToken(refreshToken: string): Observable<string> {
    return this.http
      .post<any>(this.BaseURL+'/auth/refresh', {}, {
        headers: {
          'Authorization': `Bearer ${refreshToken}`
        }
      })
      .pipe(map(response => response.access_token));
  }

  getPitch() {
    const url = "/pitch/life/LIC/Product1?age=30&dependants=2&city=NewYork&diseases=none&session_id=12345";
    return this.httpGetHelp(url);
  }

  getProducts(category: string) {
    let api = "/products/" + category + "/";
    return this.httpGetHelp(api);
  }

  getSalesPitchForHealth(payload: any, company: string, product: string) {
    const url = "/v1/sales-pitch/health/" + company + "/" + product
    return this.httpPostHelp(url, payload);
  }

  getSalesPitchForLife(payload: any, company: string, product: string) {
    const url = "/v1/sales-pitch/life/" + company + "/" + product
    return this.httpPostHelp(url, payload);
  }

  getProductResponse(payload: any, company: string, product: string, category: string) {
    const url = "/v1/product-query/" + category + "/" + company + "/" + product;
    return this.httpPostHelp(url, payload);
  }

  getSalesPitchForHealthWithProfile(customer_profile: any, company: string, product: string) {
    const url = "/v1/sales-pitch/health/" + company + "/" + product;
    const payload = { customer_profile };
    return this.httpPostHelp(url, payload);
  }

  getSalesPitchForLifeWithProfie(customer_profile: any, company: string, product: string) {
    const url = "/v1/sales-pitch/life/" + company + "/" + product;
    const payload = { customer_profile };
    return this.httpPostHelp(url, payload);
  }

  getComparisonSummaryWithProfile(customer_profile: any, company: string, product: string, category: string
    , product2: string, company2: string
  ) {
    const url = "/compare/" + category + "/" + company + "/" + product + "?customer_profile=" + customer_profile
      + "&product2=" + product2 + "&company2=" + company2;
    return this.httpGetHelp(url);
  }

  getComparisonSummaryWithFormDetails(payload: any, company: string, product: string, category: string,
    product2: string, company2: string) {
      const url = "/compare/" + category + "/" + company + "/" + product + "?&product2=" + product2 + "&company2=" + company2;
      return this.httpPostHelp(url, payload);
  }

  getComparisonSummaryWithProfileV2(payload: any, company: string, product: string, category: string, sub_category: string){
    const url = "/v1/product-comparison/" + category + "/" + sub_category;
    const requestPayload = {
      ...payload,
      company1: company,
      product1: product
    };
    return this.httpPostHelp(url, requestPayload);
  }

  addFeedback(payload: any){
    const url = "/feedback/";
    return this.httpPostHelp(url,payload);
  }

  getProductRecommendation(module: String, customer_profile: String){
    const url = "/v1/product-recommendation/" + module;
    const payload = { customer_profile };
    return this.httpPostHelp(url, payload);
  }

  getCompanyLogo(company:String){
    const url = "/logo/"+company;
    return this.http.get(this.BaseURL+url, { 
      responseType: 'blob', 
      headers: this.getAuthHeaders() 
    });
  }

  getTranscription(data: FormData){
    const url = "/audio/transcribe/";
    return this.httpPostHelp(url, data);
  }

  login(data:FormData){
    const url = "/auth/token"
    return this.httpPostHelp(url,data);
  }

  changePassword(payload: any){
    const url = "/users/change-password";
    return this.httpPostHelp(url, payload);
  }
}
